import { FieldPath, UseFormReturn } from "react-hook-form";

import { SaveIndicator } from "./SaveIndicator";
import { useSaveIndicator } from "@/hooks/useSaveIndicator";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { misc } from "@/lib/misc";
import { cn } from "@/lib/utils";

export const AutosaveFormNumberInput = <T extends Record<string, unknown>>({
  allowDecimal,
  className,
  fieldName,
  form,
  label,
  maxLength,
  onBlur,
  placeholder,
}: {
  allowDecimal?: boolean;
  className?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  label?: string;
  maxLength?: number;
  onBlur: () => Promise<void> | void;
  placeholder?: string;
}) => {
  const { handleChange, status } = useSaveIndicator();

  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem className={cn("text-slate-700", className)}>
          {label && (
            <FormLabel className="inline-flex w-full items-center justify-between">
              {label}
              <SaveIndicator status={status} />
            </FormLabel>
          )}
          <FormControl>
            <Input
              {...field}
              className="bg-slate-50 text-black"
              maxLength={maxLength}
              onChange={(e) => {
                field.onChange(e);
                handleChange();
              }}
              onBlur={() => {
                field.onBlur();
                void onBlur();
              }}
              onKeyDown={
                allowDecimal
                  ? misc.enforceCurrencyInput
                  : misc.enforceNumberInput
              }
              placeholder={placeholder}
              value={(field.value as string | number | null) ?? ""}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
